module.exports = __webpack_public_path__ + "img/Placeholder_lien.12107d1f.jpg";